import { NgModule } from '@angular/core';
import { ElementPipe } from './element.pipe';

@NgModule({
    exports: [
        ElementPipe,
    ],
    declarations: [
        ElementPipe,
    ],
})

export class ElementPipeModule {}
